import type { Answer } from "../badge/badge";
import type { Me } from "../funnel/participant";
import { sendActionEmail } from "./send";

/**
 * ═══ L'EMAIL DE CONFIRMATION, À CHAQUE INSCRIPTION ENREGISTRÉE ═══
 *
 * Les mêmes actions que la V1 (`screens/steps/Confirmation/index.jsx`, `sendEmailCb`) :
 * sur place → 1, à distance → 2, refus → 7, représenté → 6 à la personne et 5 à qui la
 * représente (par son adresse, s'il en a donné une). Chaque action ne part que si
 * l'organisateur lui a réglé un email (`skipped` sinon, voir `emails/send.ts`).
 *
 * ⚠️ À CHAQUE MODIFICATION, SANS DEMANDER SI ELLE EST DÉJÀ PARTIE (tâche #221). L'envoi
 * passait `once` : le serveur écartait qui avait déjà reçu cette action, donc corriger
 * ses jours ou sa présence ne renvoyait jamais rien, et le participant gardait dans sa
 * boîte la confirmation de ce qu'il venait de changer. C'est aussi ce que fait la V1, qui
 * renvoie à chaque passage. Ce qui protège encore d'un renvoi À VIDE (rechargement,
 * retour arrière), c'est l'APPELANT, qui n'appelle qu'après une écriture qu'il a faite
 * lui-même : la fin du tunnel (`routes/Confirmation.tsx`) et « Enregistrer »
 * (`funnel/stepSave.tsx`).
 *
 * ⚠️ PAS TANT QU'IL RESTE À PAYER, mais cette règle se lit chez l'appelant, qui tient le
 * solde : comme la V1 (`!resume?.canPay`), la confirmation attend le paiement, et c'est
 * l'action 8 qui la remplace alors (voir `Checkout`).
 *
 * Jamais bloquant : un envoi qui échoue ne doit pas défaire l'inscription qui vient
 * d'aboutir.
 */
export function sendConfirmation(
  event: { domainId: number; eventId: number },
  me: Pick<Me, "id" | "firstName" | "lastName" | "email">,
  answer: Answer | undefined,
  /** L'adresse de qui représente la personne, quand elle vient d'être donnée. */
  delegateEmail?: string,
): void {
  const send = (
    kind: Parameters<typeof sendActionEmail>[2],
    to: Parameters<typeof sendActionEmail>[3],
    variables?: Record<string, string>,
  ) =>
    void sendActionEmail(event.domainId, event.eventId, kind, to, {
      variables,
    }).catch(() => undefined);
  const userId = me.id;
  if (answer === "onsite") send("onsite", { userId });
  else if (answer === "remote") send("remote", { userId });
  else if (answer === "decline") send("decline", { userId });
  else if (answer === "represented") {
    const fromUser =
      [me.firstName, me.lastName].filter(Boolean).join(" ").trim() ||
      me.email ||
      "";
    send("delegating", { userId }, { fromUser });
    const stand = delegateEmail?.trim();
    if (stand) send("delegate", { email: stand }, { fromUser });
  }
}
